const heroStats = [
  { id: 1, value: '128', label: '今日已更新' },
  { id: 2, value: '2.4w', label: '在线吃瓜中' },
  { id: 3, value: '36', label: '正在讨论的话题' },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl"></div>
        <div className="absolute right-1/3 top-1/2 h-56 w-56 rounded-full bg-accent-100/70 blur-3xl"></div>
        <div className="absolute -right-16 bottom-0 h-64 w-64 rounded-full bg-secondary-100/70 blur-3xl"></div>
      </div>

      <div className="relative mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14 lg:py-24">
        <div className="animate-rise">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <span className="flex h-3 w-3 items-center justify-center">
              <span className="block h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse-dot"></span>
            </span>
            今日更新 · 09月12日 10:24 已上新 128 条
          </span>

          <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
            1每日吃瓜
          </h1>

          <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            今天有什么新瓜？1每日吃瓜新鲜爆料与最新八卦在这里按时间排好队，新瓜速递、今日热点一网打尽，满足你的吃瓜好奇心。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#today"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-white transition hover:bg-primary-600"
            >
              <i className="ri-fire-line text-lg"></i>
              看今日瓜
            </a>
            <a
              href="#topics"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-bold text-foreground-800 transition hover:border-secondary-300 hover:bg-secondary-100"
            >
              <i className="ri-chat-3-line text-lg"></i>
              逛话题墙
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {heroStats.map((stat) => (
              <div key={stat.id}>
                <dt className="font-heading text-2xl text-foreground-950 md:text-3xl">{stat.value}</dt>
                <dd className="mt-1 text-xs text-foreground-500 md:text-sm">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-rise lg:pl-4">
          <div className="relative mx-auto w-full max-w-[460px]">
            <div className="h-[320px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[440px]">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20warm%20coral%20orange%20and%20fresh%20watermelon%20green%20gradient%20backdrop%20with%20soft%20glowing%20bokeh%20orbs%20and%20smooth%20layered%20shapes%2C%20minimal%20modern%20editorial%20poster%20art%2C%20clean%20airy%20negative%20space%2C%20no%20text%2C%20high%20detail&width=1100&height=1100&seq=guamelon-hero-2026&orientation=squarish"
                alt="1每日吃瓜今日瓜 视觉"
                title="1每日吃瓜今日瓜"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-5 left-4 right-4 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3.5 shadow-none md:left-6 md:right-6">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-white">
                <i className="ri-flashlight-line text-xl"></i>
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-bold text-foreground-950">新瓜速递已开闸</p>
                <p className="mt-0.5 truncate text-xs text-foreground-500">
                  最近一条爆料发布于 3 分钟前
                </p>
              </div>
              <a
                href="#leaks"
                className="ml-auto flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
                aria-label="查看新鲜爆料"
              >
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}